import React, { FC, useEffect, useState } from 'react'
import { KlarnaInfo } from '@moonpig/web-shared-products'
import { PAYMENT_METHODS } from '@moonpig/web-core-brand/config'
import { useStoreId } from '@moonpig/web-core-stores'
import { Region } from '@moonpig/web-core-types'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'

type isKlarnaEnabledParams = {
  centAmount: number
  fractionDigits: number
  storeId: Region
}

const isKlarnaEnabled = ({
  centAmount,
  fractionDigits,
  storeId,
}: isKlarnaEnabledParams) => {
  const klarnaMinimalPrice = 20
  const isOrderAboveThreshold =
    centAmount / 10 ** fractionDigits >= klarnaMinimalPrice
  return isOrderAboveThreshold && PAYMENT_METHODS[storeId]?.includes('Klarna')
}

export const KlarnaInfoModule: FC<ProductModule> = props => {
  const [
    {
      product: {
        masterVariant: {
          price: {
            centAmount: masterCentAmount,
            fractionDigits: masterFractionDigits,
            currencyCode: masterCurrencyCode,
          },
        },
        variants,
      },

      selectedOptions: { variantKey: selectedVariantKey },
    },
  ] = useProductContext()

  const [centAmount, setCentAmount] = useState(masterCentAmount)
  const [currencyCode, setCurrencyCode] = useState(masterCurrencyCode)
  const [fractionDigits, setFractionDigits] = useState(masterFractionDigits)

  useEffect(() => {
    const selectedVariantByKey = variants.find(
      variant => variant.key === selectedVariantKey,
    )
    /* istanbul ignore else */
    if (selectedVariantByKey) {
      setCentAmount(selectedVariantByKey.price.centAmount)
      setCurrencyCode(selectedVariantByKey.price.currencyCode)
      setFractionDigits(selectedVariantByKey.price.fractionDigits)
    }
  }, [variants, selectedVariantKey])

  const storeId = useStoreId()

  if (isKlarnaEnabled({ centAmount, fractionDigits, storeId })) {
    return <KlarnaInfo price={centAmount} currency={currencyCode} {...props} />
  }

  return <></>
}
